import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/General/Hamburger/hamburger.container"
    ).then((module) => ({
        default: module.Hamburger
    }))
);
